import React from 'react';
import type { EvidenceStatus } from '../../data/exampleReviews';
import { cn } from '../../src/lib/utils';
const STYLES: Record<EvidenceStatus, {
  label: string;
  className: string;
}> = {
  verified: {
    label: 'Verified',
    className: 'bg-[#E8F6EE] text-[#1E7A46]'
  },
  partial: {
    label: 'Partial',
    className: 'bg-[#FDF3E7] text-[#9A5B13]'
  },
  missing: {
    label: 'Missing',
    className: 'bg-[#FDECEC] text-[#B42318]'
  },
  requested: {
    label: 'Requested',
    className: 'bg-violet-soft text-lime'
  }
};
export function StatusPill({
  status,
  className
}: {
  status: EvidenceStatus;
  className?: string;
}) {
  const style = STYLES[status];
  return <span className={cn('inline-flex shrink-0 items-center rounded-md px-1.5 py-0.5 text-[11px] font-semibold', style.className, className)} data-id="element-218" data-mp="3n4g5latbl05x">
      {style.label}
    </span>;
}